import { Calendar, BarChart3, CalendarDays } from "lucide-react";

export const navigationItems = [
  {
    path: "/",
    label: "Dashboard",
    icon: Calendar,
  },
  {
    path: "/subscriptions",
    label: "All Subscriptions",
    icon: BarChart3,
  },
  {
    path: "/calendar",
    label: "Calendar View",
    icon: CalendarDays,
  },
];
